import React from 'react';
import { useRemoveArticleInCart } from '../mutations';
import { TableCellDeleteItemVisual } from './table-cell-delete-item-visual';
import { DeleteItemCellProps } from './cart-table';

type Props = DeleteItemCellProps;

export const TableCellDeleteItem: React.FC<Props> = ({ articleId, container, erpContainerArticleId, weightKg }) => {
  const { mutateAsync: deleteArticleInCart } = useRemoveArticleInCart(
    articleId,
    container,
    erpContainerArticleId,
    weightKg,
  );

  return (
    <TableCellDeleteItemVisual
      articleId={articleId}
      handleConfirm={async () => {
        await deleteArticleInCart(null);
      }}
    />
  );
};
